<template>
  <div class="change-password-container">
    <el-card class="password-card">
      <div slot="header" class="card-header">
        <span>修改密码</span>
      </div>
      
      <el-form ref="passwordForm" :model="passwordForm" :rules="rules" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="passwordForm.oldPassword" placeholder="请输入原密码"></el-input>
        </el-form-item>
        
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入新密码"></el-input>
          <div class="password-tip">密码长度不少于6位</div>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="passwordForm.confirmPassword" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { changePassword } from '@/api/user'

export default {
  name: 'ChangePassword',
  data() {
    // 验证确认密码是否与新密码相同
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      loading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid) {
          return false
        }
        
        // 验证新密码不能与原密码相同
        if (this.passwordForm.newPassword === this.passwordForm.oldPassword) {
          this.$message.error('新密码不能与原密码相同')
          return
        }
        
        try {
          this.loading = true
          
          const response = await changePassword({
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          })
          
          if (response && response.code === 200) {
            this.$message.success('密码修改成功')
            this.resetForm()
          } else {
            this.$message.error(response.message || '密码修改失败')
          }
        } catch (error) {
          console.error('修改密码失败:', error)
          this.$message.error('修改密码失败，请稍后重试')
        } finally {
          this.loading = false
        }
      })
    },
    
    // 重置表单
    resetForm() {
      this.$refs.passwordForm.resetFields()
    }
  }
}
</script>

<style scoped>
.change-password-container {
  padding: 20px;
}

.password-card {
  max-width: 600px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.password-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style> 